import React from 'react';
import '../styles/LeaveGroupChoiceModal.css';

const LeaveGroupChoiceModal = ({ groupName, onCancel, onLeaveOnly, onDeleteForSelf, loading }) => {
  return (
    <div className="leave-group-choice-overlay" onClick={onCancel}>
      <div
        className="leave-group-choice-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="leave-group-choice-title">Leave Group</h3>
        <p className="leave-group-choice-message">
          Do you want to leave the group only, or leave and delete the group for
          yourself?
          {groupName ? (
            <>
              {' '}
              <span className="leave-group-choice-name notranslate">({groupName})</span>
            </>
          ) : null}
        </p>

        <div className="leave-group-choice-options">
          <button
            type="button"
            className="leave-group-choice-btn leave-group-choice-btn--leave"
            onClick={onLeaveOnly}
            disabled={loading}
          >
            <span className="leave-group-choice-btn-label">Leave Group</span>
            <span className="leave-group-choice-btn-hint">
              Leave the group but keep it in your chat list as read-only
            </span>
          </button>
          <button
            type="button"
            className="leave-group-choice-btn leave-group-choice-btn--delete"
            onClick={onDeleteForSelf}
            disabled={loading}
          >
            <span className="leave-group-choice-btn-label">Delete Group</span>
            <span className="leave-group-choice-btn-hint">
              Leave and remove this group from your chat list and history
            </span>
          </button>
        </div>

        <div className="leave-group-choice-footer">
          <button
            type="button"
            className="leave-group-choice-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveGroupChoiceModal;
